import { DocLayout } from './DocLayout'

export default function HelpPage() {
  return (
    <DocLayout title="Hulp en veelgestelde vragen" updated="Laatst bijgewerkt: juli 2026">
      <h2>Aan de slag</h2>
      <ul>
        <li>
          <strong>Account aanmaken:</strong> kies op de startpagina je rol (cliënt of begeleider)
          en maak een account met je e-mailadres en een wachtwoord van minstens 8 tekens met een
          letter en een cijfer.
        </li>
        <li>
          <strong>E-mail bevestigen:</strong> na registratie ontvang je een bevestigingsmail. Klik
          op de link om je account te activeren.
        </li>
        <li>
          <strong>Wachtwoord vergeten:</strong> gebruik ‘Wachtwoord vergeten?’ op het
          inlogscherm. Je ontvangt een link om een nieuw wachtwoord te kiezen.
        </li>
      </ul>

      <h2>De app gebruiken</h2>
      <ul>
        <li>
          <strong>Vandaag:</strong> je overzicht van vandaag, met je geplande activiteiten.
        </li>
        <li>
          <strong>Planner:</strong> plan activiteiten in tijdsblokken, eenmalig of terugkerend.
        </li>
        <li>
          <strong>Onthouden:</strong> leg snel iets vast dat je niet wilt vergeten.
        </li>
        <li>
          <strong>Adem:</strong> volg een rustige ademhalingsoefening in je eigen tempo.
        </li>
        <li>
          <strong>Dagboek:</strong> schrijf aan het einde van de dag op hoe het ging. Je dagboek is
          privé; begeleiders kunnen hier nooit bij.
        </li>
        <li>
          <strong>Meer:</strong> hier vind je je profiel, meldingen, toegankelijkheid, je gegevens
          en de optie om de app op je beginscherm te installeren.
        </li>
      </ul>

      <h2>Begeleiders</h2>
      <ul>
        <li>Nodig een cliënt uit via het cliëntenoverzicht; de cliënt accepteert de koppeling zelf.</li>
        <li>Je ziet alleen cliënten met een actieve koppeling.</li>
        <li>Een cliënt kan de koppeling op elk moment intrekken.</li>
      </ul>

      <h2>Problemen oplossen</h2>
      <ul>
        <li>
          <strong>‘Geen verbinding’:</strong> de app werkt deels offline; wijzigingen worden
          gesynchroniseerd zodra je weer online bent.
        </li>
        <li>
          <strong>Inloggen lukt niet:</strong> controleer je e-mailadres en wachtwoord, en of je
          via het juiste scherm inlogt (cliënt of begeleider).
        </li>
        <li>
          <strong>App reageert niet:</strong> laad de app opnieuw. Je gegevens blijven bewaard.
        </li>
      </ul>

      <h2>Contact</h2>
      <p>
        Kom je er niet uit? Mail ons via{' '}
        <a href="mailto:support@rust.mobi" style={{ color: 'var(--soft-blue)' }}>
          support@rust.mobi
        </a>
        . We reageren zo snel mogelijk.
      </p>
    </DocLayout>
  )
}
